import React, { useState } from "react";
import { Timeline, TimelineEvent } from "react-event-timeline";
import { Pagination } from 'antd';
import {
  FaSignInAlt,
  FaDownload,
  FaHeartbeat,
  FaCheck,
  FaUpload,
  //FaCircle,
  FaStream,
  //FaChartLine,
  FaExternalLinkAlt,
} from "react-icons/fa";
//import _ from "lodash";
import moment from "moment";
import InfoComponent from "./InfoComponent";
import { SCHOOL_DATA_CONSTANTS, TIMELINE_CONSTANTS } from "../constants/schoolData";

const eventIconMap = {
  login: <FaSignInAlt />,
  "resource download": <FaDownload />,
  "smart del": <FaCheck color="orange" />,
  device_vitals: <FaHeartbeat />,
  "file upload": <FaUpload />,
};

const DeviceVitalsDetails = ({ vitals }) => (
  <div>
    <span style={{ fontWeight: "500", fontSize: "10px" }}>
      {vitals.details}
    </span>
    <p>
      Has NAS: {vitals.hasNas === 1 ? "true" : "false"}
      <br />
      Wifi: {vitals.wifi}
      <br />
      IP: {vitals.ip}
    </p>
  </div>
);

const ResourceDownloadDetails = ({ event }) => (
  <div>
    <span style={{ fontWeight: "500", fontSize: "10px" }}>({event.app}) </span>
    <span style={{ fontWeight: "500", fontSize: "10px" }}>{event.details}</span>
  </div>
);

const DateDivider = ({ date }) => (
  <div
    style={{
      margin: "8px 18px ",
      padding: "2px",
      borderTop: "2px dotted #ddd",
    }}
  >
    <span
      style={{
        fontSize: "11px",
        fontWeight: 700,
        padding: "0 10px",
        color: "red",
      }}
    >
      {moment(date).format("dddd, D-MMMM-YYYY")}
    </span>
  </div>
);

const DeviceTimeline = ({
  timelineLoading,
  deviceData,
  updateActivitiesDropDown,
  pagination,
  onChangePagination,
  showSimplePagination = false,
  deviceId
}) => {
  const [viewType, setViewType] = useState("select_view");

  const handleViewTypeChange = (e) => {
    const selectedView = e.target.value;
    setViewType(selectedView);
    if (selectedView !== "select_view") {
      updateActivitiesDropDown(selectedView);
      onChangePagination(1);
    }
  };

  const getMetabaseDashboardUrl = (viewType) => {
    const baseUrl = "https://metabase.leadschool.in/";
    //const mdmDeviceId = deviceId && deviceId.mdmDeviceId ? deviceId.mdmDeviceId : '';

    switch (viewType) {
      case "with_casting":
        return `https://metabase.leadschool.in/question/2017-activity-timeline-by-mdm-device-id?mdm_id=${deviceId}`;
      case "without_casting":
        return `${baseUrl}question/2017-activity-timeline-by-mdm-device-id?mdm_id=${deviceId}`;
      case "basic":
      default:
        return "https://metabase.leadschool.in/dashboard/405-ta-important-dashboards";
    }
  };
  const data = viewType === "sd_card_view" ? deviceData?.data || [] : deviceData || [];
  const totalEntries = viewType === "sd_card_view"
    ? deviceData?.total_entries
    : deviceData?.length ? parseInt(deviceData[0]?.total_entries, 10) : 0;

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <div>
          <label htmlFor="viewType">View Type: </label>
          <select id="viewType" value={viewType} onChange={handleViewTypeChange}>
            <option value="select_view">Select View</option>
            <option value="basic">Basic</option>
            <option value="with_casting">Resource Used With Casting</option>
            <option value="without_casting">Resource Used Without Casting</option>
            <option value="sd_card_view">SD Card View</option>
          </select>
        </div>
        <a
          href={getMetabaseDashboardUrl(viewType)}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: '12px', color: '#1890ff' }}
        >
          Metabase Dashboard <FaExternalLinkAlt style={{ marginLeft: '4px', fontSize: '10px' }} />
        </a>
      </div>

      {viewType === "select_view" ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          Please select a view to see the timeline.
        </div>
      ) : (
        <>
          <div className="timeline-pagination-container">
            <Pagination
              className={`timeline - pagination - component ${showSimplePagination ? '' : 'mr-40'} `}
              defaultCurrent={TIMELINE_CONSTANTS.DEFAULT_PAGE_NO}
              current={pagination.page}
              total={totalEntries}
              defaultPageSize={pagination.limit}
              showSizeChanger
              pageSizeOptions={TIMELINE_CONSTANTS.PAGE_SIZE_CONFIG}
              onChange={onChangePagination}
              prevIcon="Prev"
              nextIcon="Next"
              simple={showSimplePagination}
            />
          </div>
          {!timelineLoading ? (
            <Timeline>
              {(Array.isArray(data) ? data : []).map((event, index, self) => (
                <React.Fragment key={`timeline - ${index + 1} `}>
                  {self.findIndex((c) => c.received.split(' ')[0] === event?.received.split(' ')[0]) === index && (
                    <DateDivider date={event?.received} />
                  )}
                  <TimelineEvent
                    title={event.event}
                    createdAt={event.received.split(" ")[1]}
                    icon={eventIconMap[event.event] || <FaStream />}
                    titleStyle={{ color: "#ff7929", fontSize: "11px" }}
                  >
                    {event.details && viewType === "basic" ?
                      (
                        event.event === "device_vitals" ? (
                          <DeviceVitalsDetails vitals={event} />
                        ) : event.event === "resource download" ? (
                          <ResourceDownloadDetails event={event} />
                        ) : (
                          <p>{event.details}</p>
                        )
                      ) : viewType === "with_casting" ? (
                        <p>{`${event.details} `}</p>
                      ) : viewType === "without_casting" ? (
                        <p>{`${event.details} `}</p>
                      ) : viewType === "sd_card_view" ? (
                        <p>{`${event.details} `}</p>
                      ) : null}
                  </TimelineEvent>
                </React.Fragment>
              ))}
            </Timeline>
          ) : (
            <InfoComponent message={SCHOOL_DATA_CONSTANTS.messages.loading} />
          )}
        </>
      )}
    </div>
  );
};

export default DeviceTimeline;
